/**
 * PATH: apps/qa/src/lib/api/helpers.ts
 * PURPOSE: Shared API helpers — lazy client getter and list normalisation
 */

import { getConfiguredClient } from '../setupApi'

/** Lazy API client getter — call at request time, not module load */
export const api = () => getConfiguredClient()

/** Normalise paginated or plain-array responses into { results, count } */
export function normaliseList<T>(data: unknown): { results: T[]; count: number } {
  if (Array.isArray(data)) return { results: data as T[], count: data.length }
  if (data && typeof data === 'object' && 'results' in data) {
    const obj = data as Record<string, unknown>
    const results = Array.isArray(obj.results) ? (obj.results as T[]) : []
    return { results, count: typeof obj.count === 'number' ? obj.count : results.length }
  }
  return { results: [] as T[], count: 0 }
}

/** Normalise a response into a plain array */
export function normaliseArray<T>(data: unknown): T[] {
  if (Array.isArray(data)) return data as T[]
  if (data && typeof data === 'object' && 'results' in data) {
    const results = (data as Record<string, unknown>).results
    return Array.isArray(results) ? (results as T[]) : []
  }
  return []
}
